export enum RoiFilterEnum {
  ALL = "all",
  P5 = "5",
  P10 = "10",
  P25 = "25",
  P50 = "50",
  P100 = "100",
}
